export const menulist = {
  name: "learner 6",
  administrator: {
    name: "Administrator",
    status: false,
    administrator: [
      {
        access: false,
        icon: "dashboard",
        id: 1,
        key: "dashboard",
        menuName: "Dashboard",
        path: "dashboard",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "course",
        id: 2,
        key: "course",
        menuName: "Course",
        path: "course",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "courselist",
        id: 3,
        key: "courselist",
        menuName: "Course List",
        path: "courselist",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "people",
        id: 4,
        key: "people",
        menuName: "People",
        path: "people",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "group",
        id: 5,
        key: "group",
        menuName: "Group",
        path: "group",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "report",
        id: 6,
        key: "report",
        menuName: "Report",
        path: "report",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [
          {
            access: false,
            icon: "people",
            id: 6,
            key: "people",
            menuName: "People",
            path: "people",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "course",
            id: 7,
            key: "course",
            menuName: "Course",
            path: "course",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "group",
            id: 7,
            key: "group",
            menuName: "Group",
            path: "group",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "coursetask",
            id: 7,
            key: "course task",
            menuName: "Course Task",
            path: "course",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "activitylog",
            id: 7,
            key: "activitylog",
            menuName: "Activity Log",
            path: "activitylog",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
        ],
      },
      {
        access: false,
        icon: "settings",
        id: 5,
        key: "settings",
        menuName: "Settings",
        path: "settings",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [
          {
            access: false,
            icon: "account",
            id: 6,
            key: "account",
            menuName: "Account",
            path: "Account",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "people",
            id: 7,
            key: "people",
            menuName: "People",
            path: "people",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "course",
            id: 7,
            key: "course",
            menuName: "Course",
            path: "course",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "category",
            id: 7,
            key: "category",
            menuName: "Category",
            path: "category",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
        ],
      },
    ],
  },
  tutor: {
    name: "Tutor",
    status: false,
    tutor: [
      {
        access: false,
        icon: "dashboard",
        id: 2,
        key: "dashboard",
        menuName: "Dashboard",
        path: "dashboard",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "course",
        id: 3,
        key: "course",
        menuName: "Course",
        path: "course",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "group",
        id: 3,
        key: "group",
        menuName: "Group",
        path: "group",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "scoring",
        id: 3,
        key: "scoring",
        menuName: "Scoring",
        path: "scoring",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "conference",
        id: 3,
        key: "conference",
        menuName: "Conference",
        path: "conference",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "report",
        id: 4,
        key: "report",
        menuName: "Report",
        path: "report",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [
          {
            access: false,
            icon: "course",
            id: 5,
            key: "course",
            menuName: "Course",
            path: "course",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "coursetask",
            id: 6,
            key: "coursetask",
            menuName: "Course Task",
            path: "coursetask",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
          {
            access: false,
            icon: "activitylog",
            id: 5,
            key: "activitylog",
            menuName: "Activity Log",
            path: "activitylog",
            permission: {
              create: false,
              delete: false,
              edit: false,
              view: false,
            },
          },
        ],
      },
      {
        access: false,
        icon: "calendar",
        id: 3,
        key: "calendar",
        menuName: "Calendar",
        path: "calendar",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
    ],
  },
  learner: {
    name: "Learner",
    status: false,
    learner: [
      {
        access: false,
        icon: "dashboard",
        id: 2,
        key: "dashboard",
        menuName: "Dashboard",
        path: "dashboard",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "my course",
        id: 3,
        key: "my course",
        menuName: "My course",
        path: "my course",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "courselist",
        id: 4,
        key: "courselist",
        menuName: "Course List",
        path: "courselist",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
      {
        access: false,
        icon: "calendar",
        id: 5,
        key: "calendar",
        menuName: "Calendar",
        path: "calendar",
        permission: {
          create: false,
          delete: false,
          edit: false,
          view: false,
        },
        subMenu: [],
      },
    ],
  },
  created_at: new Date().toLocaleDateString(),
};
